import { render, staticRenderFns } from "./SourceMp4.vue?vue&type=template&id=8661a8dc&scoped=true"
import script from "./SourceMp4.vue?vue&type=script&lang=js"
export * from "./SourceMp4.vue?vue&type=script&lang=js"
import style0 from "./SourceMp4.vue?vue&type=style&index=0&id=8661a8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661a8dc",
  null
  
)

export default component.exports